import React from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import App from './App';
createRoot(document.getElementById('root')!).render(<App data-id="element-417" data-mp="1wbmnhgp93kki" />);